










































import Draggable from 'vuedraggable';
import { IProductProp } from '@/services/product/types';
import { GridColumn, GridTable } from '@/components/grid';
import ShowGuide from '@/components/ShowGuide.vue';

export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Properties',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    shape: {
      key: '',
      value: '',
    },
  }),
  computed: {
    localValue: {
      get(): IProductProp[] {
        return this.value;
      },
      set(value: IProductProp[]) {
        this.$emit('input', value);
      },
    },
  },
  components: {
    Draggable,
    GridColumn,
    GridTable,
    ShowGuide,
  },
} as IView;
